import { render, staticRenderFns } from "./report_table.vue?vue&type=template&id=51d943e2&"
import script from "./report_table.vue?vue&type=script&lang=js&"
export * from "./report_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports